module.exports = __webpack_public_path__ + "img/icon_real_time_1.77efee63.png";